import React, { useRef, useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AzyByteTechLanding.css';
import Navbar from './Navbar';
import Footer from './Footer';
import emailjs from '@emailjs/browser';
import AOS from 'aos';
import { Helmet } from 'react-helmet-async';

function Contact() {
  const form = useRef();
  const [status, setStatus] = useState("");

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    // ADD YOUR PUBLIC KEY AS THE 4TH ARGUMENT BELOW
    emailjs.sendForm(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    form.current,
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY)
    .then(() => {
          setStatus("Message Sent Successfully!");
          form.current.reset();
      }, (error) => {
          setStatus("Failed to send. Please try WhatsApp.");
          console.log(error.text);
      });
  };

  return (
    <div style={{ paddingTop: '10px' }}> {/* Prevents Navbar overlap */}
    <Helmet>
        <title>
          Contact AzyByte Technologies | Free IT Consultancy & Project Discussion
        </title>

        <meta
          name="description"
          content="Contact AzyByte Technologies for web development, software engineering, AI automation, mobile applications, cloud solutions, and a free IT consultancy session."
        />

        <meta
          name="keywords"
          content="Contact AzyByte Technologies, AzyByte , AzyByte Nadiad , IT Consultancy Nadiad, Web Development Company Nadiad, Software Development Services, AI Automation Solutions"
        />

        <link
          rel="canonical"
          href="https://www.azybyte.in/contact"
        />

        <meta
          property="og:title"
          content="Contact AzyByte Technologies"
        />

        <meta
          property="og:description"
          content="Get in touch with AzyByte Technologies for software development, AI automation, websites, mobile apps, and digital transformation services."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://www.azybyte.in/contact"
        />

        <meta
          property="og:image"
          content="https://www.azybyte.in/azybytelogo.png"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "Contact AzyByte Technologies",
            url: "https://www.azybyte.in/contact",
            description:
              "Contact AzyByte Technologies for software development, web applications, AI automation, and IT consultancy."
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            name: "AzyByte Technologies",
            url: "https://www.azybyte.in",
            telephone: "+91-9998203277",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Nadiad",
              addressRegion: "Gujarat",
              addressCountry: "IN"
            },
            areaServed: "India",
            sameAs: [
              "https://www.linkedin.com/company/azybytetechnologies",
              "https://instagram.com/azybytetech"
            ]
          })}
        </script>
     </Helmet>
    <Navbar />


      <section className="bg-light py-5 mt-5">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h1 className="fw-bold mb-3">Contact Us - AzyByte</h1>
              <p className="lead mb-0">
                Have a question or need assistance? Get in touch with our team and we'll be happy to help.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="py-5">
        <div className="container py-4">

          <div className="row g-4">
            <div className="col-md-4">
              <div className="contact-card text-center p-4 p-md-5 h-70 d-flex flex-column justify-content-center">

                <div>
                  <div className="icon-box bg-success-subtle text-success mb-4 mx-auto d-flex align-items-center justify-content-center">
                    <i className="bi bi-whatsapp fs-4"></i>
                  </div>

                  <h5 className="fw-bold mb-2">Chat on WhatsApp</h5>
                  <p className="text-muted mb-4 small">
                    Quick response guaranteed
                  </p>
                </div>

                <div className="d-grid gap-2 mt-2">
                  <a
                    href="https://wa.me/918460444634?text=Hello,I'm%20inquiring%20for%20service%20from%20AzyByte Technologies"
                    className="btn btn-success rounded-pill py-2"
                  >
                    Business Inquiries (BDM-Business Development Manager)
                  </a>

                  <a
                    href="https://wa.me/919998203277?text=Hello,I'm%20inquiring%20for%20service%20from%20AzyByte Technologies"
                    className="btn btn-outline-success rounded-pill py-2"
                  >
                    Project & Technical (Agency Head)
                  </a>
                </div>
              </div>
            </div>

            {/* Email (replaces Call Us) */}
            <div className="col-md-4">
              <div className="contact-card text-center p-5 h-100">
                <div className="icon-box bg-danger-subtle text-danger mb-3">
                  <i className="bi bi-envelope"></i>
                </div>
                <h5 className="fw-bold">Email Us</h5>
                <p className="text-muted">We are here to help you out. <br />
                 Please reach out us at below given mail. <br /> Our team will reply within 24 hours .
                  <br /><b>contact@azybyte.in</b>
                </p>
                <a
                  href="mailto:contact@azybyte.in"
                  className="btn btn-outline-danger rounded-pill px-4"
                >
                  Send Email
                </a>
              </div>
            </div>

             {/* Location */}
            <div className="col-md-4">
              <div className="contact-card text-center p-5 h-100 justify-content-center">
                <div className="icon-box bg-primary-subtle text-primary mb-3">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <h5 className="fw-bold">Our Operating Location</h5>
                <p className="text-muted mb-0">
               3rd Floor, AzyByte Technologies <br />
               Above Navjivan Electronics <br />
               Gurukrupa Society, Pij Road <br />
               Nadiad, Gujarat - 387002

                </p>
                  <a
                  href="https://maps.app.goo.gl/AkR7cySqdV7jLJT1A"
                  className="btn btn-outline-info rounded-pill px-4 m-3"
                >
                  Open Map
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>



      {/* The Main Form Section */}
      <section id="contact-form" className="py-5 bg-light">
        <div className="container py-4">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5" data-aos="fade-right">
              <h2 className="fw-bold mb-4">Let's Build Something <span className="text-primary">Secure</span></h2>
              <p className="text-muted">Fill out the form and our technical team will get back to you within 24 hours with a custom solution plan.</p>
              <div className="mt-4 p-3 bg-white rounded-3 shadow-sm border-start border-primary border-4">
                <p className="mb-0 small fst-italic">"Security is not an option, it's a standard at AzyByte."</p>
              </div>
            </div>

            <div className="col-lg-7" data-aos="fade-left">
              {/* Added a real border to make the card visible */}
              <div className="card border-0 shadow-lg p-4 p-md-5 bg-white">
                <form ref={form} onSubmit={sendEmail}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label small fw-bold text-dark">Full Name</label>
                      <input type="text" name="from_name" className="form-control bg-light border-0" placeholder="Enter name here" required />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-bold text-dark">Email Address</label>
                      <input type="email" name="from_email" className="form-control bg-light border-0" placeholder="example@gmail.com" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-bold text-dark">Service Required</label>
                      <select name="service" className="form-select bg-light border-0">
                        <option>Website Development</option>
                        <option>Mobile App Development</option>
                        <option>Ecommerce Development</option>
                        <option>Wordpress/Shopify Development</option>
                        <option>IoT Development</option>
                        <option>Security Audit</option>
                        <option>Consultant/Others</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-bold text-dark">Message</label>
                      <textarea name="message" className="form-control bg-light border-0" rows="4" placeholder="Briefly describe your project..." required></textarea>
                    </div>
                    <div className="col-12 mt-4">
                      <button type="submit" className="btn btn-primary w-100 py-3 rounded-pill fw-bold shadow">
                        Send Secure Message
                      </button>
                      {status && (
                        <div className={`text-center mt-3 p-2 rounded small fw-bold ${status.includes('Success') ? 'bg-success-subtle text-success' : 'bg-primary-subtle text-primary'}`}>
                          {status}
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contact;